module.exports = __webpack_public_path__ + "img/info-zh.361af90e.jpg";